/**
 * 객체에서 `data-*` 키만 추출.
 *
 * 사용처: `Header.Action` 의 wrapper span 처럼 *structural selector hook* (호스트 adapter 의 inline script,
 * HeaderLeft/Right sibling logic 등) 이 data-* 를 보는 layer 에 한정해 propagate 할 때.
 *
 * # 사용
 *
 * ```tsx
 * <span {...pickDataAttrs(rest)} data-core-ui-action={action}>
 *   <button {...omitDataAttrs(rest)} data-action={action}>...</button>
 * </span>
 * ```
 */
export function pickDataAttrs<T extends Record<string, unknown>>(props: T): Record<string, unknown> {
  const result: Record<string, unknown> = {};
  for (const key in props) {
    if (key.startsWith('data-')) {
      result[key] = props[key];
    }
  }
  return result;
}

/**
 * 객체에서 `data-*` 키를 *제외* 한 나머지만 추출.
 *
 * `pickDataAttrs` 의 보완재. wrapper 가 data-* 를 가져가고, 내부 interactive element 는 *그 외 rest props*
 * (aria-*, onMouseEnter, id, style 등) 를 받게 분리할 때.
 */
export function omitDataAttrs<T extends Record<string, unknown>>(props: T): Record<string, unknown> {
  const result: Record<string, unknown> = {};
  for (const key in props) {
    if (!key.startsWith('data-')) {
      result[key] = props[key];
    }
  }
  return result;
}
